import { ISuggestion, ISuggestionComplaint, ISuggestionType } from '../../models'
import {
  IAddSuggestionAction,
  IAddSuggestionSuccessfulAction,
  ISetIsLoadingSuggestionsAction,
  SuggestionsTypeKeys
} from '../types'

export function addSuggestionAction(
  type: ISuggestionType,
  title: string,
  affair: ISuggestionComplaint,
  description: string,
  anonymous: boolean,
  serviceInfoId: number
): IAddSuggestionAction {
  const suggestion: ISuggestion = { type, title, affair, description, anonymous, serviceInfoId }
  return { type: SuggestionsTypeKeys.ADD_SUGGESTION, payload: suggestion }
}

export function addSuggestionSuccessfulAction(): IAddSuggestionSuccessfulAction {
  return { type: SuggestionsTypeKeys.ADD_SUGGESTION_SUCCESSFUL }
}

export function setIsLoadingSuggestionsAction(loading: boolean): ISetIsLoadingSuggestionsAction {
  return { type: SuggestionsTypeKeys.IS_LOADING_SUGGESTIONS, payload: loading }
}
